import type { MainPageBlock } from '@entities/MainPageConfig'

import type { LandingBlockProps } from '@features/landing-page-builder/model/blockRegistry'
import { blockComponents } from '@features/main-page-builder/model/blockRegistry'

import styles from './MainPageLikeBlock.module.scss'

/*
  Adapter for the block types a landing shares with the main page config
  (bannerGallery, categories, personalOffers, coupons, loyaltyLevel, custom, and
  the CMS-banner form of `banner`).

  The landing block envelope is a superset of the main page one — same
  type/subtype/payload — so these are delegated to the existing main-page
  renderers instead of being reimplemented. Landing-specific extras on the
  envelope (target, visibleForStates) are meaningless to them and simply unused.
*/
export default function MainPageLikeBlock ({ block, payload, shopId }: LandingBlockProps) {
  const BlockComponent = block.type ? blockComponents[block.type] : null

  if (!BlockComponent) {
    return null
  }

  return (
    <div className={styles.root}>
      <BlockComponent
        block={{
          type: block.type,
          subtype: block.subtype ?? undefined,
          order: block.order ?? 0,
          payload,
        } as unknown as MainPageBlock}
        payload={payload}
        shopId={shopId}
      />
    </div>
  )
}
